import React from 'react';
import _ from 'lodash';
import { I18n } from '@aws-amplify/core';
import { SearchOutlined } from '@ant-design/icons';
import { useOwasEvaluationContext } from '../context';
import * as S from './styles';

export function Input() {
	const { onFilterName } = useOwasEvaluationContext();

	const handleOnChange = _.debounce((value) => {
		handleOnChangeName(value);
	}, 1000);

	function handleOnChangeName(name: string): void {
		onFilterName(name);
	}

	return (
		<S.InputWrapper
			size="large"
			prefix={<SearchOutlined />}
			placeholder={I18n.get('Search for a task')}
			onChange={(e) => handleOnChange(e.target.value)}
		/>
	);
}
